import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
Vue.prototype.$axios = axios

import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

Vue.config.productionTip = false
console.log(process.env);
Vue.prototype.$api_base = process.env.VUE_APP_API_BASE;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

